import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	dateFilterLabel: {
		id: 'software-reports-cumulative-flow-diagram.controls.date-filter-label',
		defaultMessage: 'Date filter',
		description: 'Date filter input label for the CFD next-gen report',
	},
	fromDateLabel: {
		id: 'software-reports-cumulative-flow-diagram.controls.from-date-label',
		defaultMessage: 'From date',
		description: 'From date filter input label for the CFD next-gen report',
	},
	toDateLabel: {
		id: 'software-reports-cumulative-flow-diagram.controls.to-date-label',
		defaultMessage: 'To date',
		description: 'End date filter input label for the CFD next-gen report',
	},
});

export default messages;
